<template>
  <autocomplete v-model="searchQuery" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
    <template #item="props">
     <strong>{{props.item.reference_code }}</strong> {{ props.item.description ? `(${props.item.description})` : ''}}
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'ItemAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    restrictTo: {
      type: Array,
      default: () => []
    },
    includes: {
      type: Array,
      default: () => ['item_tracking']
    },
    filter: {
      type: Function,
      default: (x) => x
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50'
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Reference Code')
    }
  },
  methods: {
    onInputChange(query) {
      let params = {
        includes: this.includes,
        sort: [
          {
            key: 'reference_code',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['reference_code', 'ct', query.trim()]
            ]
          }
        ]
      }

      if (Array.isArray(this.restrictTo) && this.restrictTo.length > 0) {
        params.filter_groups.push({
          filters: this.restrictTo
        })
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'items', {params: params})
            .then(response => {
              resolve(response.body.data.filter(x => this.filter(x)))
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
